export const LinearGradientColorBgAnimation = ({ 
  children,
  width,
  height,
  style,
  childrenContainerStyle,
}: { 
  children?: React.ReactNode;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
  childrenContainerStyle?: React.CSSProperties;
}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: width ?? '100%',
        height: height ?? '100%',
        overflow: 'hidden',
        borderRadius: '10px 10px 0 0',
        ...style,
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: '#F4FFFC',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: 'radial-gradient(circle at 25% -15%, #EEFFCE 0%, transparent 55%)',
          filter: 'blur(70px)',
          animation: 'floatCircle1 4s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: 'radial-gradient(circle at 80% 200%, #CEFFFB 0%, transparent 45%)',
          filter: 'blur(70px)',
          animation: 'floatCircle2 5s ease-in-out infinite 0.5s',
        }}
      />
      <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%', ...childrenContainerStyle }}>
        {children}
      </div>
      <style>{`
        @keyframes floatCircle1 {
          0%, 100% {
            transform: translate(0%, 0%) scale(1.2);
            opacity: 1;
          }
          25% {
            transform: translate(-15%, 20%) scale(1.6);
            opacity: 0.95;
          }
          50% {
            transform: translate(12%, -15%) scale(0.9);
            opacity: 1;
          }
          75% {
            transform: translate(-10%, 10%) scale(1.4);
            opacity: 0.9;
          }
        }
        
        @keyframes floatCircle2 {
          0%, 100% {
            transform: translate(0%, 0%) scale(1.1);
            opacity: 1;
          }
          30% {
            transform: translate(18%, -12%) scale(1.5);
            opacity: 1;
          }
          60% {
            transform: translate(-12%, 15%) scale(0.85);
            opacity: 0.95;
          }
          85% {
            transform: translate(14%, -8%) scale(1.3);
            opacity: 0.9;
          }
        }
      `}</style>
    </div>
  );
};
